<template lang="html">
    <section class="orders-people-associated">
        <div class="assiciated-list">
            <ul>
                <li>Joe smith</li>
                <li>BorisOliviero</li>
                <li>Joe smith</li>
                <li>BorisOliviero</li>
            </ul>
        </div>
    </section>
</template>

<script lang="js">
  export default  {
    name: 'orders-people-associated',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes.scss";

.orders-people-associated {
    @extend %primary-text;
    ul {
        padding: 0;
        margin: 0;
        list-style: none;
        font-weight: bold;
        line-height: 25px;
    }
}
</style>



// WEBPACK FOOTER //
// order-people-associated.vue?def430ac